/**
 * Utilidades para normalizar el nombre de plataforma de una reserva.
 *
 * Diferenciación importante — son DOS orígenes distintos:
 *  - `Stays` → reserva que entró por el sitio/canales integrados vía la API
 *    de Stays.net. Para el usuario final se muestra como "Web".
 *  - `Directa`/`Directo` → reserva creada manualmente por un admin desde
 *    el panel de Aloja Fácil. Se muestra como "Directo".
 *
 * El resto (`AirBnb`, `Booking`, `Despegar`, ...) se muestra tal cual.
 */

/**
 * Convierte el valor crudo de plataforma (tal como viene de la DB) a la
 * etiqueta que se muestra al usuario.
 */
export function formatPlataforma(name?: string | null): string {
  if (!name) return "-";
  const key = name.trim().toLowerCase();
  if (key === "stays") return "Web";
  if (key === "directa" || key === "directo") return "Directo";
  return name;
}
